<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    width="550px"
    class="default-dialog"
  >
  <div class="title">设置五险一金</div>
    <el-form label-position="right" label-width="120px" :model="form" :rules="rules" ref="wxyj" size="small">
        <el-form-item label="缴纳项目：" prop="name">
            <el-input placeholder="请输入" v-model="form.name" size="mini" style="width:350px" :disabled="form.isSystemProject" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="缴纳基数：" prop="baseMoney">
            <el-input placeholder="请输入" v-model="form.baseMoney" size="mini" style="width:350px" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="公司缴纳比例：" prop="companyPayRatio" >
          <div class="acc_flex_1">
            <div class="acc_flex">
               <el-input placeholder="请输入" v-model="form.companyPayRatio" size="mini" style="width:200px;margin-right:10px"></el-input>
               <div>%</div>
            </div>  
            <div class="proportion" :title="companyPayRatio_proportion">{{companyPayRatio_proportion}}元</div>
          </div>
        </el-form-item>
        <el-form-item label="个人缴纳比例：" :prop="(form.name=='生育保险'||form.name=='工伤保险')?'':'personalPayRatio'">
          <div class="acc_flex_1">
            <div class="acc_flex">
              <el-input placeholder="请输入" v-model="form.personalPayRatio" size="mini" style="width:200px;margin-right:10px" :disabled="form.name=='生育保险'||form.name=='工伤保险'"></el-input>
              <div>%</div>
            </div>
            <div class="proportion" :title="personalPayRatio_proportion">{{personalPayRatio_proportion}}元</div>
          </div>
        </el-form-item>
    </el-form>
    <div class="footer acc_flex">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" class="submit" @click="submit" >确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {insuranceTask} from '@/api/index'
export default {
  data() {
    return {
      visible: false,
      rules:{
        name:[ { required: true, message: '请输入缴纳项目', trigger: 'blur' },],
        baseMoney:[{ required: true, message: '请输入缴纳基数', trigger: 'blur' },{ validator: this.validate_baseMoney, trigger: 'blur' }],
        companyPayRatio:[ { required: true, message: '请输入公司缴纳比例', trigger: 'blur' },{ validator: this.validate_Number, trigger: 'blur' }],
        personalPayRatio:[ { required: true, message: '请输入个人缴纳比例', trigger: 'blur' },{ validator: this.validate_Number, trigger: 'blur' }]
      },
      form: {
        baseMoney:"",
        name: "",
        companyPayRatio: "",
        personalPayRatio: "",
      },
    };
  },
  computed:{
    companyPayRatio_proportion(){
      return (Number(this.form.baseMoney)*(Number(this.form.companyPayRatio)/100)).toFixed(2)||0
    },
    personalPayRatio_proportion(){
      return (Number(this.form.baseMoney)*(Number(this.form.personalPayRatio)/100)).toFixed(2)||0
    }
  },
  methods: {
    validate_Number(rule, value, callback){
      let reg = /^(\d{1,2}(?:\.\d{0,2})?|100(?:\.0{1,2})?)$/
      if(!reg.test(value)){
        return callback(new Error('缴纳比例值为0-100'))
      }else {
        callback()
      }
    },
    validate_baseMoney(rule, value, callback){
      let reg = /\b\d{1,10}\b/
      if(!reg.test(value)){
        return callback(new Error('请输入10位数的正数'))
      }else {
        callback()
      }
    },
    submit(){
        this.$refs.wxyj.validate((valid) => {
          if (valid) {
            let params =  this.$lodash.cloneDeep(this.form)
            params.companyPayRatio = Number(params.companyPayRatio).toFixed(2)
            params.personalPayRatio = Number(params.personalPayRatio).toFixed(2)
            params.companyPayMoney = this.companyPayRatio_proportion
            params.personalPayMoney = this.personalPayRatio_proportion
            delete params.uuid
            insuranceTask(params).then(res=>{
              if(res.data.code==1){
                this.$message.success(res.data.msg)
                this.$emit('refrensh')
                this.visible = false
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
        
    },
    openTask(type, row) {
      this.visible = true;
      this.$nextTick(()=>{
        this.$refs.wxyj.clearValidate()
      })
      if (type == "add") {
         this.form = {
             baseMoney:"",
             name: "",
             companyPayRatio: "",
             personalPayRatio: "",
         }
      } else {
        this.form = {...row}
        // this.form.companyPayRatio = this.form.companyPayRatio?this.form.companyPayRatio*100:null
        // this.form.personalPayRatio = this.form.personalPayRatio?this.form.personalPayRatio*100:null
      }
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.proportion {
  // width: 70px;
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  color: #FF6010;
}

.footer {
  margin-top: 44px;
  justify-content: center;
  /deep/ .el-button {
    width: 100px;
  }
  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269D7B;
  }
}
/deep/ .el-dialog__header,
/deep/ .el-dialog__footer {
  display: none !important;
}
/deep/ .el-dialog__body {
  padding: 30px 40px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/components/UpdateWxyj.vue